import React, { Component, lazy, Suspense } from 'react';
import { Route, Switch, RouteComponentProps } from 'react-router-dom';
import CompanyInfoDetail from './Detail';
import CompanyInfoEdit from './Edit';
import EditEntrance from 'containers/OutCompanyManagement/OutCompanyInfo/EditEntrance';
import DetailsEntrance from 'containers/OutCompanyManagement/OutCompanyInfo/DetailsEntrance';
import EditNew from './EditNew';
import AccidentDetail from '../Accident/Detail';

// 协同端事故「处理」按钮：按 oaNo 跳 OA 反馈流程壳页面（§4.3）。
// 必须 lazy 加载：OaFlow 依赖 @purchase/flow-detail（ESM，顶层链 @flow-engine/flow-detail 引擎 +
// @bedrock/web-components 的 .css 副作用导入）。若静态 import，makeRoutes 的同步
// require('../containers/OutCompanyManagement/OutCompanyInfo/index') 会把它拉进 OutCompanyInfo 求值链，
// 引擎模块求值失败 → 整个 OutCompanyInfo require 抛错被 catch 吞掉 → 「公司管理」TAB 404。
// lazy 隔离：只在进 oaFlow 路由时才加载，公司管理不受牵连。
const AccidentOaFlow = lazy(() => import('../Accident/OaFlow'));

class CompanyInfo extends Component<RouteComponentProps, any> {

  public render() {
    const { match: { path } } = this.props
    return (
      <Switch>
        <Route exact path={`${path}`} component={DetailsEntrance} />
        <Route path={`${path}/edit`} component={EditEntrance} />
        <Route path={`${path}/editNew`} component={EditNew} />
        <Route path={`${path}/accident/detail/:accidentId`} component={AccidentDetail} />
        <Route
          path={`${path}/accident/oaFlow/:oaNo`}
          render={(props) => (
            <Suspense fallback={null}>
              <AccidentOaFlow {...props} />
            </Suspense>
          )}
        />
      </Switch>
    );
  }
}

export default CompanyInfo;
